<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import type { ManageAPI } from "~/manage-api/types";
  import { parseDateISO, formatDate,parseExceptionalOpeningHoursItem } from "~/util/date-n-time";

  export let request_store_key: StoresKey;
  export let store: ManageAPI.Store;

  const { reverse_router, scdata, T, locale } = getStoresContext(request_store_key);
  $: t = $T;
  $: exceptional_openinghours_formatted = (store.exceptionalOpeningHours || []).map((item) => {
    return {
      ...item,
      date: formatDate(parseDateISO(item.date), $locale, { day: 'numeric', month: 'numeric' }),
      hours: parseExceptionalOpeningHoursItem( $locale, item )
    };
  });
</script>

<div class="col-12 px-0">
  <div class="row border-bottom p-lg-3 p-2">
    <div class="col-7">
      <a href= {$reverse_router.routeStore(store, $scdata)} class="link fw-bold">
        {store.name}
      </a>
    </div>
    <div class="col-5">
      {store.openingHours.replace(/-|-/g, '–')}
      {#if exceptional_openinghours_formatted.length > 0}
        <div class="mb-3">
          {#each exceptional_openinghours_formatted as item}
            <div class="right-inner-description colored-text exception">
              <span>{item.date}</span>
              <span>{@html item.open ? item.hours : t`opening-status-closed`}</span>
              <span>{item.reason}</span>
            </div>
          {/each}
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="scss">
  .link {
    text-decoration: none;
  }

  .right-inner-description {
    color: #000;
  }
  .colored-text {
    color: #dc3545;
  }

  .exception span {
    display: inline-block;
  }
</style>
